import {
  Component,
  Input,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { EntityDetailDisplayMode } from '../../../../../shared/definitions/entity-detail-display-mode.enum';

@Component({
  selector: 'entity-detail-attribute',
  standalone: false,
  templateUrl: './entity-detail-attribute.component.html',
  styleUrls: ['./entity-detail-attribute.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
  encapsulation: ViewEncapsulation.None,
})
export class EntityDetailAttributeComponent {
  @Input() displayMode: EntityDetailDisplayMode;
  @Input() layout: any;
  @Input() label: TemplateRef<any>;
  @Input() value: TemplateRef<any>;

  get classes() {
    const classNames = [];

    classNames.push(this.displayMode);

    if (this.layout) {
      switch (this.displayMode) {
        case EntityDetailDisplayMode.View:
          classNames.push(this.layout.view);
          break;
        case EntityDetailDisplayMode.Edit:
          classNames.push(this.layout.edit);
          break;
        case EntityDetailDisplayMode.Create:
          classNames.push(this.layout.create);
          break;
        default:
      }
    }

    return classNames;
  }
}
